export default __webpack_public_path__ + "static/media/zdh_light_01.bba6c5a1.webp";